import {Component, OnInit} from '@angular/core';

import {PrimeNGConfig} from 'primeng-lts/api';
import {FcmService} from "./entities/common/firebase-notification/firebase.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  message: any;

  constructor(
    private primengConfig: PrimeNGConfig,
    private fcmService: FcmService
  ) {
  }

  ngOnInit(): void {
    this.primengConfig.ripple = true;
    this.fcmService.receiveMessage();
  }

  requestPermission() {
    this.fcmService.requestPermission();
  }

}
